// The Exchange Alliance guided tour — independent of VEROOGLE.
import { INTAKE_CUES } from "./ExchangeIntakeSection";
import { PILLAR_CUES } from "./ExchangePillarsSection";
import { SANCTUARY_CUES } from "./ExchangeSanctuarySection";
import { CAREER_CUES } from "./ExchangeCareerSection";
import { CLEARING_CUES } from "./ExchangeClearingSection";
import { CHURCH_CUES } from "./ExchangeChurchSection";
import { COMMERCE_CUES } from "./ExchangeCommerceSection";
import { PILOT_CUES } from "./ExchangePilotSection";
import { JOURNEY_CUES } from "./ExchangeJourneySection";

const _BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

export const exchangeAudioUrl = (slug, step, version) => {
  const url = `${_BASE}/api/static/audio/${slug}-step-${step}.mp3`;
  return version ? `${url}?v=${encodeURIComponent(version)}` : url;
};

export const EXCHANGE_TOUR_SCRIPT = [
  {
    id: "beat01",
    chip: "01 · Welcome",
    step: "01",
    target: "exchange-beat01-hero",
    kicker: "// 01 · THE EXCHANGE ALLIANCE",
    title: "The Exchange Alliance",
    caption: "",
  },
  {
    id: "beat02",
    chip: "02 · Government",
    step: "02",
    target: "exchange-gov-section",
    dock: "exchange-gov-dock",
    cues: [
      { phrase: "cost avoidance", target: "exchange-gov-card-cost-roi" },
      { phrase: "inter-agency", target: "exchange-gov-card-data-sharing" },
      { phrase: "bed capacity", target: "exchange-gov-card-bed-capacity" },
      { phrase: "grant compliance", target: "exchange-gov-card-grant-ledger" },
    ],
    kicker: "// 02 · GOVERNMENT & MUNICIPALITIES",
    title: "Government & Municipalities",
    caption: "",
  },
  {
    id: "church",
    chip: "03 · Churches",
    step: "CH",
    target: "exchange-church-section",
    dock: "exchange-church-dock",
    kicker: "// 03 · CHURCHES & NONPROFITS",
    title: "Churches & Nonprofits",
    caption: "",
    cues: CHURCH_CUES,
  },
  {
    id: "commerce",
    chip: "04 · Commerce",
    step: "CM",
    target: "exchange-commerce-section",
    dock: "exchange-commerce-dock",
    kicker: "// 04 · COMMERCE, CORPORATE & SMALL BUSINESS",
    title: "Commerce, Corporate & Small Business",
    caption: "",
    cues: COMMERCE_CUES,
  },
  {
    id: "pillars",
    chip: "05 · Pillars",
    step: "PL",
    target: "exchange-pillars-section",
    dock: "exchange-pillars-dock",
    kicker: "// 05 · THE FOUR PILLARS · COMMITMENT TO CAREER",
    title: "The Four Pillars",
    caption: "",
    cues: PILLAR_CUES,
  },
  {
    id: "beat03",
    chip: "06 · Intake",
    step: "03",
    target: "exchange-intake-section",
    dock: "exchange-intake-dock",
    kicker: "// 06 · INTAKE PROCESS",
    title: "Intake Process",
    caption: "",
    cues: INTAKE_CUES,
  },
  {
    id: "beat04",
    chip: "07 · Sanctuary",
    step: "04",
    target: "exchange-sanctuary-section",
    dock: "exchange-sanctuary-dock",
    kicker: "// 07 · SANCTUARY & CAMPUS OPERATIONS",
    title: "Sanctuary & Campus Operations",
    caption: "",
    cues: SANCTUARY_CUES,
  },
  {
    id: "beat05",
    chip: "08 · Career",
    step: "05",
    target: "exchange-career-section",
    dock: "exchange-career-dock",
    kicker: "// 08 · EMPLOYMENT & SPRINT TO CAREER",
    title: "Employment & Sprint to Career",
    caption: "",
    cues: CAREER_CUES,
  },
  {
    id: "beat06",
    chip: "09 · Clearinghouse",
    step: "06",
    target: "exchange-clearing-section",
    dock: "exchange-clearing-dock",
    kicker: "// 09 · CLEARINGHOUSE & FINANCIAL FREEDOM",
    title: "Clearinghouse & Financial Freedom",
    caption: "",
    cues: CLEARING_CUES,
  },
  {
    id: "beat07",
    chip: "10 · Journey",
    step: "07",
    target: "exchange-journey-section",
    dock: "exchange-journey-dock",
    kicker: "// 10 · A RESIDENT'S JOURNEY",
    title: "Streets to Graduation",
    caption: "",
    cues: JOURNEY_CUES,
  },
  {
    id: "pilot",
    chip: "11 · Pilot",
    step: "PI",
    target: "exchange-pilot-section",
    dock: "exchange-pilot-dock",
    kicker: "// 11 · YOUR 90-DAY PILOT",
    title: "Book a Pilot",
    caption: "",
    cues: PILOT_CUES,
  },
];
